import { render, staticRenderFns } from "./Termination.vue?vue&type=template&id=bb76679a&scoped=true"
import script from "./Termination.vue?vue&type=script&lang=js"
export * from "./Termination.vue?vue&type=script&lang=js"
import style0 from "./Termination.vue?vue&type=style&index=0&id=bb76679a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb76679a",
  null
  
)

export default component.exports